<script lang="ts">
  import { onMount } from "svelte";
  import { decodeEntities, setJS } from "../../helpers/helperMethods";

  interface Props {
    content: string;
  }

  let { content = $bindable() }: Props = $props();

  content = decodeEntities(content);

  let container = $state();
  onMount(() => {
    /**
     * Toggles view on component provided, used for extensible components
     * @param {*} element
     */
    setJS(content);

    document.querySelectorAll(".extensible-wrapper").forEach((section: Element) => {
      (section as HTMLElement & { onbeforematch?: () => void }).onbeforematch = () => {
        section.classList.add("extended");
        section.classList.remove("not-extended");
      };

      const extensible = section.querySelector(".extensible") as HTMLElement;
      const content = section.querySelector(".extensible-content") as HTMLElement;

      if (!extensible || !content) return;

      extensible.onclick = () => {
        section.classList.toggle("not-extended");
        if (section.classList.contains("not-extended")) {
          (content as any).hidden = "until-found";
          section.classList.remove("extended");
          section.classList.add("not-extended");
        } else {
          section.classList.add("extended");
          section.classList.remove("not-extended");
          content.removeAttribute("hidden");
        }
      };

      if (window.location.hash && extensible.id === window.location.hash.substring(1)) {
        section.classList.add("extended");
        section.classList.remove("not-extended");
        content.removeAttribute("hidden");
      }
    });
  });
</script>

<div bind:this={container} class="container ugc">
  {@html content}
</div>
